import React, { useEffect, useState } from 'react'
import { Delete, Pencil, Search } from '../../common/Icons'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { toaster } from '../../apis/commonFunctions'
import { deleteRequest, getRequest, patchRequest, postRequest } from '../../apis/functions'
import APIS from '../../apis/routes'
import NoDataRow from '../../common/NoDataRow'
import LoadingRow from '../../common/LoadingRow'
import Button from '../../common/Button'
import Pagination from '../../common/Pagination'
import moment from 'moment/moment'
import Switch from "react-switch"

export default function Intention() {
    const [all, setAll] = useState([]);
    const router = useNavigate();
    const [skip, setSkip] = useState(0);
    const [limit, setLimit] = useState(0);
    const [mainid, setMainId] = useState("");
    const [total, setTotal] = useState(0);
    const [params] = useSearchParams();
    const search = params.get('search') || "";
    const [loading, setLoading] = useState(false);

    const [newIntention, setNewIntention] = useState("");
    const [newPremium, setNewPremium] = useState(false);

    const [editId, setEditId] = useState("");
    const [editIntention, setEditIntention] = useState("");
    const [editPremium, setEditPremium] = useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getRequest(
                `${APIS.GET_INTENTION}?search=${search}&skip=${skip}&limit=${limit}`
            );
            setLoading(false);
            if (!result.data.status) {
                toaster(result.data.message, false);
            } else {
                console.log("result.data.data : ", result.data.data);
                setAll(result.data.data);
                setTotal(result.data.total_count);
            }
        } catch (err) {
            toaster(err.message, false);
            setLoading(false);
        }
    };

    function handlePageClick({ selected }) {
        setSkip(selected * limit);
    }

    useEffect(() => {
        fetchData();
    }, [search, skip]);

    const addIntention = async (obj) => {
        try {
            setLoading(true);
            const result = await postRequest(APIS.CREATE_INTENTION, obj);
            setLoading(false);
            if (!result.data.status) {
                toaster(result.data.message, false);
            } else {
                toaster(result.data.message, true);
                fetchData();
            }
        } catch (err) {
            toaster(err.message, false);
        }
    };

    const handleAddIntention = async () => {
        const payload = {
            intention: newIntention,
            is_premium: newPremium,
        };
        await addIntention(payload);
        setNewIntention("");
        setNewPremium(false);
        const closeBtn = document.getElementById("closeAddIntentionModal");
        if (closeBtn) closeBtn.click();
    };

    const handleEdit = (item) => {
        setEditId(item._id);
        setEditIntention(item.prompt);
        setEditPremium(item.is_premium);
    };

    // Update the intention using the patchRequest
    const handleUpdateIntention = async () => {
        const payload = {
            intention: editIntention,
            is_premium: editPremium,
        };
        try {
            setLoading(true);
            const result = await patchRequest(`${APIS.UPDATE_INTENTION}/${editId}`, payload);
            setLoading(false);
            if (!result.data.status) {
                toaster(result.data.message, false);
            } else {
                toaster(result.data.message, true);
                fetchData();
            }
        } catch (err) {
            toaster(err.message, false);
        }
        const closeBtn = document.getElementById("closeEditIntentionModal");
        if (closeBtn) closeBtn.click();
    };

    const handleDelete = async () => {
        try {
            const result = await deleteRequest(`${APIS.DELETE_INTENTION}/${mainid}`);
            if (result.data.status) {
                toaster(result.data.message, true);
                fetchData();
            } else {
                toaster(result.data.message, false);
            }
        } catch (err) {
            toaster(err.message, false);
        }
    };

    return (
        <>
            <div className="top_bar row align-items-center mt-3">
                <div className="col-lg-6">
                    <div className="pagetitle">
                        Intention Management <br />
                    </div>
                </div>
                <div className="col-lg-6 text-end">
                    <Button
                        text="Add Intention"
                        className="btn btn-success"
                        data-bs-toggle="modal"
                        data-bs-target="#add_intention"
                    />
                </div>
            </div>

            <div className="row mt-5">
                <div className="table-responsive">
                    <table className="table table-lg">
                        <thead className="table-light">
                            <tr>
                                <th>S.No</th>
                                <th>Intention</th>
                                <th>Premium</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading && all.length <= 0 && <NoDataRow />}
                            {loading && <LoadingRow />}
                            {all && all.length > 0 &&
                                all.map((element, index) => (
                                    <tr key={element._id}>
                                        <td>{index + 1}</td>
                                        <td style={{ textTransform: "inherit" }}>{element.prompt}</td>
                                        <td style={{ textTransform: "unset" }}>
                                            {element.is_premium ? "Yes" : "No"}
                                        </td>
                                        <td style={{ textTransform: "unset" }}>
                                            {moment(element.createdAt).format("DD MMM YYYY")}
                                        </td>
                                        <td>
                                            <div className="actions">
                                                <button
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#editIntentionModal"
                                                    onClick={() => handleEdit(element)}
                                                >
                                                    <Pencil />
                                                </button>
                                                <button
                                                    className="delete"
                                                    onClick={() => setMainId(element._id)}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#deleteIntentionModal"
                                                >
                                                    <Delete />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                            {total > limit && (
                                <tr className="text-center">
                                    <td colSpan={20}>
                                        <Pagination handlePageClick={handlePageClick} totalCount={total} limit={limit} />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ------------------ Add Intention Modal ------------------ */}
            <div
                className="modal fade"
                id="add_intention"
                tabIndex="-1"
                aria-labelledby="addIntentionModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title" id="addIntentionModalLabel">Add Intention</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="closeAddIntentionModal"
                            ></button>
                        </div>

                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="intentionInput" className="form-label">Intention</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="intentionInput"
                                    value={newIntention}
                                    onChange={(e) => setNewIntention(e.target.value)}
                                    placeholder="Enter intention..."
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="premiumInput" className="form-label">Premium</label>
                                <div>
                                    <Switch
                                        onChange={(checked) => setNewPremium(checked)}
                                        checked={newPremium}
                                        offColor="#888"
                                        onColor="#0d6efd"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleAddIntention}
                                disabled={!newIntention || loading}
                            >
                                {loading ? (
                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                        Saving...
                                    </>
                                ) : (
                                    "Save"
                                )}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            {/* ------------------ End Add Intention Modal ------------------ */}

            {/* ------------------ Edit Intention Modal ------------------ */}
            <div
                className="modal fade"
                id="editIntentionModal"
                tabIndex="-1"
                aria-labelledby="editIntentionModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editIntentionModalLabel">Edit Intention</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="closeEditIntentionModal"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="editIntentionInput" className="form-label">Intention</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="editIntentionInput"
                                    value={editIntention}
                                    onChange={(e) => setEditIntention(e.target.value)}
                                    placeholder="Enter intention..."
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="editPremiumInput" className="form-label">Premium</label>
                                <div>
                                    <Switch
                                        onChange={(checked) => setEditPremium(checked)}
                                        checked={editPremium}
                                        offColor="#888"
                                        onColor="#0d6efd"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleUpdateIntention}
                                disabled={!editIntention || loading}
                            >
                                {loading ? (
                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                        Saving...
                                    </>
                                ) : (
                                    "Save Changes"
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* ------------------ End Edit Intention Modal ------------------ */}

            {/* ------------------ Delete Intention Modal ------------------ */}
            <div
                className="modal fade"
                id="deleteIntentionModal"
                tabIndex="-1"
                aria-labelledby="deleteIntentionModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteIntentionModalLabel">Confirm Deletion</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            Are you sure you want to delete this item?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                data-bs-dismiss="modal"
                                onClick={handleDelete}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* ------------------ End Delete Intention Modal ------------------ */}
        </>
    );
}
